import React, { Component, Fragment } from 'react';
import { I18n, Translate } from 'react-redux-i18n';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { css } from 'aphrodite/no-important';
import isEmpty from 'lodash/isEmpty';
import styles from './Home.styles';
import { ICON_TYPE } from '../../constants/icons';
import { FILTER_TYPE, listViewColumns, locationColumn } from '../../constants/data';
import {
  editTagAction,
  updateTagsTimeAction,
  getAreasAction,
  getTagsAction,
  selectTagAction,
  setCurrentTagAction,
  addFilterAction,
  removeFilterAction,
  deleteTagAction,
  downloadCSVHistoryAction,
  getHistoryAction,
  setHistoryAction,
  setCurrentAreaAction,
  streamTagsAction,
  closeStreamTagsAction,
  getLocationsGeoJsonAction,
  clearTagsAction,
  addInfoAction,
  addTagAction,
  bulkUploadAction,
  bulkUploadClearAction,
  getOrgSitesAction,
  addCategoryAction,
  getFilteredCategoriesAction,
  getFilteredGroupsAction,
  addGroupAction,
  editCategoryAction,
  setCurrentCategoryAction,
  setCurrentGroupAction,
  editGroupAction,
  deleteGroupAction,
  deleteCategoryAction,
  expandCollapseAction,
  setSortingAction
} from '../../reducers/actions';
import {
  getFilteredTags,
  findSelectedTag,
  getSuperTags,
  getFilteredCategories,
  getFilteredGroups,
  getFilteredSortedTagsOfArea,
  getMapViewColumns
} from '../../utils/selectors';

import DataTable from '../../components/data/datatable/DataTable';
import ErrorBoundary from '../../components/common/errorboundary/ErrorBoundary';
import TagsMap from '../../components/data/tagsmap/TagsMap';
import HistoryMap from '../../components/data/historymap/HistoryMap';
import Modal from '../../components/common/modal/Modal';
import ModalTabView from '../../components/common/modaltabview/ModalTabView';
import ModalTabPanel from '../../components/common/modaltabpanel/ModalTabPanel';
import Confirm from '../../components/common/confirm/Confirm';

import AddButton from '../../components/inputs/addbutton/AddButton';
import AddSelection from '../../components/common/addselection/AddSelection';
import AddTagForm from '../../components/forms/addtagform/AddTagForm';
import BulkUploadFileForm from '../../components/forms/bulkupload/BulkUploadFileForm';
import BulkUploadResults from '../../components/forms/bulkupload/bulkuploadresults/BulkUploadResults';
import AddGroupForm from '../../components/forms/addgroupform/AddGroupForm';
import AddCategoryForm from '../../components/forms/addcategoryform/AddCategoryForm';
import SearchInput from '../../components/inputs/searchinput/SearchInput';
import ListItems from '../../components/common/listitems/ListItems';
import DeleteCategoryForm from '../../components/forms/deletecategoryform/DeleteCategoryForm';

import LoadingMask from '../../components/common/LoadingMask.js';
import Notification from '../../components/common/notification/Notification';
import MapBar from '../../components/common/mapBar/MapBar';
import { accessColumnData } from '../../utils/transform';
import { FileService } from '../../services';

const NoHistoryDiv = props => {
  let s = props.nodata ? styles.nohistory : styles.hide;
  return (
    <div className={css(s)}>
      <Translate value="data.noHistory" />
    </div>
    )
}

function initMouseEvents(e){
  e.preventDefault();
  e.stopPropagation();
  let re = new Event('resize');
  let resize=(e)=>{
    let n = document.getElementById('map-container');
    if(window.innerHeight -20 > e.clientY){
      n.style.height = e.clientY - n.offsetTop + 'px';
      n.style.flexGrow = 0;
    }else{
      e.stopPropagation();
      e.preventDefault();
    }
  }
  let resizeDone=(e)=>{
    window.dispatchEvent(re);
    window.removeEventListener('mousemove', resize,false);
  }
  window.addEventListener('mousemove', resize, false);
  window.addEventListener('mouseup', resizeDone, {once: true});
}


export class Home extends Component {
  state = {
    showAddModal: false,
    showAddTagModal: false,
    showAddGroupModal: false,
    showAddCategoryModal: false,
    showAddBulkUploadModal: false,
    showResultsBulkUploadModal: false,
    showEditCategoryListModal: false,
    showEditGroupListModal: false,
    showEditCategoryModal: false,
    showEditGroupModal: false,
    showDeleteGroupModal: false,
    showDeleteCategoryModal: false,

    showEditTagModal: false,
    showDeleteTagModal: false,
    showHistory: false,
    scrollToTopToggle: false,
    showLiveButton: true,
    disableStreamTagButton: true
  };
  constructor(props){
    super(props);
    this.resizableHandle = React.createRef();
  }
  componentDidMount() {
    let n = this.resizableHandle.current;
    // this.props.clearTags();
    if (n) {
      n.addEventListener('mousedown', initMouseEvents);
    }

    if(this.props.tagsCount){
      this.setState({ disableStreamTagButton: false })
    }
    if (this.props.currentArea && this.props.currentArea.id) {
      this.props.getTags(this.props.currentSite.id, undefined, undefined, undefined, undefined, undefined, this.props.currentArea.id);
    }
  }
  componentWillUnmount() {
    let n = this.resizableHandle.current;
    if (n) {
      n.removeEventListener('mousedown', initMouseEvents);
    }
    this.props.closeStreamTags();
  }
  shouldComponentUpdate(nextProps, nextState) {
    if (this.props.currentSite !== nextProps.currentSite) {
      this.props.closeStreamTags();
      this.setState( {showLiveButton: true});
    }
    if (this.props.currentArea && !this.props.currentArea.hasOwnProperty('id') && nextProps.currentArea.hasOwnProperty('id')) {
      this.props.getLocationsGeoJson(nextProps.currentArea.id);
    }
    if (this.props.currentArea && nextProps.currentArea.hasOwnProperty('id') && this.props.currentArea.id !== nextProps.currentArea.id) {
      this.props.getTags(this.props.currentSite.id, undefined, undefined, undefined, undefined, undefined, nextProps.currentArea.id);
    }
    if (this.props.tagsCount !== nextProps.tagsCount) {
      const allowStream = !!nextProps.tagsCount;
      this.setState({ disableStreamTagButton: !allowStream })
    }
    if (!isEmpty(nextProps.bulkResults) && isEmpty(this.props.bulkResults)) {
      this.handleBulkUploadResult(nextProps.bulkResults);
    }
    if (
      (this.props.currentArea &&
        nextProps.currentArea &&
        this.props.currentArea.id !== nextProps.currentArea.id) ||
      (this.props.currentSite &&
        nextProps.currentSite &&
        this.props.currentSite.id !== nextProps.currentSite.id) ||
      (!nextProps.selectedTag && this.state.showHistory)
    ) {
      this.setState({ showHistory: false });
      return false;
    }
    return true;
  }

  streamTags(site) {
    if (site && site.id) {
      this.props.streamTags(site.id);
    }
  }

  handleAdd = () => {
    this.setState({ showAddModal: true });
  };

  handleAddSelection = ({ value }) => {
    this.props.setCurrentTag({});
    this.props.setCurrentCategory({});
    this.props.setCurrentGroup({});
    this.setState({ showAddModal: false, [`showAdd${value}Modal`]: true });
  };

  handleEditSelection = ({ value }) => {
    this.props.getFilteredCategories();
    this.props.getFilteredGroups();

    this.props.setCurrentTag({});
    this.props.setCurrentGroup({});
    this.setState({ showAddModal: false, [`showEdit${value}Modal`]: true });
  };

  handleAddTagSubmit = values => {
    values.account = this.props.account;
    values.site = this.props.currentSite;
    this.props.addTag(values);
    this.handleAddClose();
  };

  handleBulkUpload = values => {
    this.props.bulkUploadClear();
    if (values.file) {
      URL.revokeObjectURL(values.file.preview);
    }
    this.props.addInfo("Bulk upload in progress");
    this.props.bulkUpload(values.file[0], this.props.currentSite.id);
  };
  handleBulkResultsClose = () => {
    this.setState({
      showResultsBulkUploadModal: false
    });
    this.props.getAreas(this.props.currentSite.id, true, this.props.account);
  };

  handleAddGroupSubmit = values => {
    const group = {
      account: this.props.account,
      name: values.name,
      site: this.props.currentSite.id
    };
    this.props.addGroup(group);
    this.handleAddClose();
  };

  handleEditGroupSubmit = value => {
    this.props.editGroup(value);
    this.handleAddClose();
  };

  handleDeleteGroup = () => {
    this.setState({ showDeleteGroupModal: true });
    this.handleAddClose();
  };

  handleAddCategory = values => {
    const category = {
      account: this.props.account,
      name: values.name,
      site: this.props.currentSite.id
    };
    this.props.addCategory(category);
    this.handleAddClose();
  };

  handleEditCategorySubmit = values => {
    this.props.editCategory(values);
    this.handleAddClose();
  };

  handleDeleteCategory = () => {
    this.setState({ showDeleteCategoryModal: true });
    this.handleAddClose();
  };

  handleDeleteTagConfirm = () => {
    this.props.deleteTag(
      {
        ...this.props.currentTag,
        site: this.props.currentSite,
        account: this.props.account
      },
      this.props.currentArea.id
    );
    this.handleDeleteClose();
  };

  handleCategorySearchChange = e => {
    this.setState({ categorySearchValue: e.currentTarget.value });
  };

  handleCategorySearch = (e) => {
    if ((e.charCode || e.keyCode) === 13) {
      this.props.getFilteredCategories(this.state.categorySearchValue);      
    }
  }

  handleEditCategory = value => {
    this.props.setCurrentCategory(value);
    this.setState({
      showEditCategoryListModal: false,
      showEditCategoryModal: true
    });
  };

  handleGroupSearchChange = e => {
    this.setState({ groupSearchValue: e.currentTarget.value });
  };

  handleGroupSearch = (e) => {
    if ((e.charCode || e.keyCode) === 13) {
      this.props.getFilteredGroups(this.state.groupSearchValue);      
    }
  }

  handleEditGroup = value => {
    this.props.setCurrentGroup(value);
    this.setState({
      showEditGroupListModal: false,
      showEditGroupModal: true
    });
  };

  handleDeleteGroupConfirm = () => {
    this.props.deleteGroup(this.props.currentGroup.id);
    this.handleDeleteClose();
  };

  handleDeleteCategoryConfirm = value => {
    const category = {
      id: this.props.currentCategory.id,
      categoryReplacement: value.category
    };
    this.props.deleteCategory(category);
    this.handleDeleteClose();
  };

  handleBulkUploadResult = () => {
    this.handleAddClose();
    this.setState({ showResultsBulkUploadModal: true });
  };

  handleAddClose = () => {
    this.setState({
      showEditTagModal: false,
      showAddModal: false,
      showAddTagModal: false,
      showAddGroupModal: false,
      showAddCategoryModal: false,
      showAddBulkUploadModal: false,
      showResultsBulkUploadModal: false,
      showEditCategoryListModal: false,
      showEditCategoryModal: false,
      showEditGroupListModal: false,
      showEditGroupModal: false
    });
  };
  handleDeleteClose = () => {
    this.setState({
      showDeleteTagModal: false,
      showEditTagModal: false,
      showDeleteGroupModal: false,
      showDeleteCategoryModal: false
    });
  };
  handleEditTagSubmit = values => {
    values.account = this.props.account;
    values.site = this.props.currentSite;
    this.props.editTag(values);
    this.handleAddClose();
  };
  handleDeleteTag = () => {
    this.setState({ showDeleteTagModal: true });
    this.handleAddClose();
  };
  handleDeleteTagConfirm = () => {
    this.props.deleteTag(
      {
        ...this.props.currentTag,
        site: this.props.currentSite,
        account: this.props.account
      },
      this.props.currentArea.id
    );
    this.handleDeleteClose();
  };
  onMapClick = () => {
    if (this.props.selectedTag) {
      this.props.selectTag(this.props.selectedTag);
    }
  };
  onMapMove = map => {
    const { lng, lat } = map.getCenter();
    this.setState({ lng, lat, zoom: map.getZoom() });
  };
  onSuperTagClick = tagId => {
    if (this.props.selectedTag !== tagId) {
      this.props.selectTag(tagId);
    }
  };
  onLocationClick = location => {
    const locationName = (typeof location.name === 'string' && location.name.split('@')[0]) || location.name;
    this.props.addFilter({
      type: FILTER_TYPE.COLUMN,
      column: locationColumn.Header,
      accessor: locationColumn.accessor,
      value: location.name,
      name: locationName,
      sortField: locationColumn.sortField
    });
  };
  onEdit = tag => {
    this.props.setCurrentTag(tag);
    this.setState({ showEditTagModal: true });
  };
  addFilter = data => {
    this.setState({ showHistory: false });
    this.props.selectTag({});
    this.props.addFilter(data);
  };
  selectTag = tagId => {
    this.setState({ showHistory: false });
    if (tagId && tagId !== this.props.selectedTag) {
      this.navigateToTagArea(tagId);
    }
    this.props.selectTag(tagId);
  };
  expandCollapseRow = (tagId) => {
    this.props.expandTag(tagId);
  };
  showHistory = (startDate, endDate) => {
    if(!startDate && !endDate){
      let s = new Date();
      s.setHours(s.getHours() - 1);
      startDate = s;
      endDate = new Date();
    }
    this.props.clearHistory();
    this.props.getHistory(this.props.selectedTag, startDate, endDate);
    this.setState({ showHistory: true, nohistory: false });
  };
  handleExport = () => {
    const macAddresscolumn =  {
      Header: I18n.t('models.tag.mac'), 
      accessor: 'macAddress'
    };
    const displayedColumns = listViewColumns.filter(column => !column.hidden);
    displayedColumns.splice(1, 0, macAddresscolumn);
    const headerList = displayedColumns.map((column) => {
      return column.Header.toUpperCase();
    });

    const tagsList = this.props.tagsData.map((tag) => 
      displayedColumns.map((column) => accessColumnData(tag, column))
    );

    const rows = [
      headerList,
      ...tagsList
    ];
    
    let csvContent = rows.map(rowArray => rowArray.join(',')).join('\r\n');
    FileService.downloadInBrowser(csvContent, 'tag-list.csv');
  }

  setSorting = data => {
    this.props.setSorting(data);
  };

  renderResize(){
    return (
      <div id="resize-handle" ref={this.resizableHandle} className={css(styles.resizeHandle)}><i className="fas fa-arrows-alt-v"></i></div>
    )
  };
  navigateToTagArea = tagId => {
    const tag = this.props.tagsData.find((tag) => tag.id === tagId);
    const areaId = tag && tag.areaId;

    if (areaId && this.props.currentArea && areaId !== this.props.currentArea.id) {
      const area = this.props.areas.find((area) => area.id === areaId);
      if (area) {
        this.props.setCurrentArea(area, true);
        this.setState( {scrollToTopToggle : !this.state.scrollToTopToggle});
      }
    }
  };

  goToListView = () => {
    this.props.history.push('/');
  };

  onMapLiveClick = () => {
    this.streamTags(this.props.currentSite);
    this.setState( {showLiveButton: false});
  }

  onMapStopClick = () => {
    this.props.closeStreamTags();
    this.setState( {showLiveButton: true});
  }

  onRefresh = () => {
    this.props.getTags(this.props.currentSite.id, undefined, undefined, undefined, undefined, undefined, this.props.currentArea.id);
  };

  render() {
    if (!this.props.sitesLoading && !this.props.sitesList.length) {
      return <Redirect to='/no-sites-found' />;
    }
    const { lat, lng, zoom } = this.state;
    return (
      <Fragment>
        <LoadingMask show={this.props.loading} />
        <div className={css(styles.base)}>
          <ErrorBoundary>
            <MapBar
              onLiveClick={this.onMapLiveClick}
              onStopClick={this.onMapStopClick}
              showLiveButton={this.state.showLiveButton}
              disableButtons={this.state.disableStreamTagButton}
            ></MapBar>
            {!this.state.showHistory ? (
              <div id="map-container" className={css(styles.mapDiv)}>
                <TagsMap
                  area={this.props.currentArea}
                  zones={this.props.zones}
                  locations={this.props.locations}
                  tags={
                    this.props.currentArea &&
                    this.props.currentArea.id &&
                    this.props.currentAreaTags
                  }
                  superTags={this.props.superTagsList}
                  selectedTag={this.props.selectedTag}
                  onClick={this.onMapClick}
                  onMove={this.onMapMove}
                  onLocationClick={this.onLocationClick}
                  onSuperTagClick={this.onSuperTagClick}
                  options={{
                    ...(lat && lng && zoom && { center: [lng, lat], zoom })
                  }}
                  defaultGeoJson={this.props.locationsGeoJson}
                />
                {this.renderResize()}
              </div>
            ) : (
              <div id="map-container" className={css(styles.mapDiv)}>
                <NoHistoryDiv
                  nodata={(this.props.historyGeodata && this.props.historyGeodata.features.length === 0)} />
                <HistoryMap
                  currentTag={this.props.currentTag}
                  area={this.props.currentArea}
                  zones={this.props.zones}
                  history={this.props.historyGeodata}
                  list={this.props.historySortedEvents}
                  showHistory={this.showHistory}
                  onMove={this.onMapMove}
                  options={{
                    ...(lat && lng && zoom && { center: [lng, lat], zoom })
                  }}
                />
                {this.renderResize()}
              </div>
            )}
          </ErrorBoundary>
          <ErrorBoundary>
            <DataTable
              styles={styles.list}
              columns={this.props.columns}
              data={this.props.currentAreaTags}
              isDataGrouped={false}
              selected={this.props.currentArea && this.props.currentArea.id}
              filteredBy={this.props.filters}
              addFilter={this.addFilter}
              removeFilter={this.props.removeFilter}
              onRowClick={this.selectTag}
              selectedRow={this.props.selectedTag}
              onRowExpand={this.expandCollapseRow}
              onEdit={this.onEdit}
              showHistory={this.showHistory}
              onTagDelete={this.handleDeleteTag}
              onHistoryDownload={this.props.downloadCSVHistory}
              onExport={this.handleExport}
              tagsCount={this.props.tagsCount}
              scrollToTopToggle={this.state.scrollToTopToggle}
              goToListView={this.goToListView}
              onRefresh={this.onRefresh}
              onSort={this.setSorting}
              sorting={this.props.sorting}
            />
            <AddButton onClick={this.handleAdd} styles={styles.addButton} />
          </ErrorBoundary>
          <Modal
            isOpen={this.state.showDeleteTagModal}
            onRequestClose={this.handleDeleteClose}
            contentLabel="Delete Tag"
            title={I18n.t('delete.deleteTag')}
          >
            <Confirm
              itemName={this.props.currentTag && this.props.currentTag.name}
              confirm={this.handleDeleteTagConfirm}
              deny={this.handleDeleteClose}
            />
          </Modal>

          <Modal
            isOpen={this.state.showAddModal}
            onRequestClose={this.handleAddClose}
            contentLabel="Add Modal"
            title={I18n.t('add.add')}
          >
            <ModalTabView>
              <ModalTabPanel header="Add">
                <AddSelection
                  onClick={this.handleAddSelection}
                  options={[
                    {
                      name: I18n.t('add.addTag'),
                      value: 'Tag',
                      iconType: ICON_TYPE.SVG,
                      iconValue: 'tag'
                    },
                    {
                      name: I18n.t('add.addGroup'),
                      value: 'Group',
                      iconType: ICON_TYPE.SVG,
                      iconValue: 'server'
                    },
                    {
                      name: I18n.t('add.addCategory'),
                      value: 'Category',
                      iconType: ICON_TYPE.SVG,
                      iconValue: 'briefcase'
                    },
                    {
                      name: I18n.t('add.bulkUpload.title'),
                      value: 'BulkUpload',
                      iconType: ICON_TYPE.LINEAR,
                      iconValue: 'upload'
                    }
                  ]}
                />
              </ModalTabPanel>
              <ModalTabPanel header="Edit">
                <AddSelection
                  onClick={this.handleEditSelection}
                  options={[
                    {
                      name: I18n.t('edit.category.category'),
                      value: 'CategoryList',
                      iconType: ICON_TYPE.SVG,
                      iconValue: 'briefcase'
                    },
                    {
                      name: I18n.t('edit.group.group'),
                      value: 'GroupList',
                      iconType: ICON_TYPE.SVG,
                      iconValue: 'server'
                    }
                  ]}
                />
              </ModalTabPanel>
            </ModalTabView>
          </Modal>
          <Modal
              isOpen={this.state.showAddTagModal || this.state.showEditTagModal}
              onRequestClose={this.handleAddClose}
              contentLabel={
                this.state.showAddTagModal ? 'Add Tags Modal' : 'Edit Tags Modal'
              }
              title={I18n.t(
                this.state.showAddTagModal ? 'add.tag.title' : 'edit.tag.title'
              )}
            >
              <AddTagForm
                onSubmit={
                  this.state.showAddTagModal
                    ? this.handleAddTagSubmit
                    : this.handleEditTagSubmit
                }
                categories={this.props.categories}
                groups={this.props.groups}
                initialValues={this.props.currentTag}
                isEditing={this.state.showEditTagModal}
                onDelete={this.handleDeleteTag}
                onCancel={this.handleAddClose}
              />
            </Modal>
          <Modal
            isOpen={this.state.showAddBulkUploadModal}
            onRequestClose={this.handleAddClose}
            contentLabel="Bulk Upload Modal"
            title={I18n.t('add.bulkUpload.title')}
          >
            <BulkUploadFileForm
              onSubmit={this.handleBulkUpload}
              onCancel={this.handleAddClose}
            />
          </Modal>
          <Modal
            isOpen={
              this.state.showResultsBulkUploadModal &&
              'recordCount' in this.props.bulkResults
            }
            onRequestClose={this.handleBulkResultsClose}
            contentLabel="Bulk Upload Results Modal"
            title={I18n.t('add.bulkUpload.resultsTitle')}
          >
            <BulkUploadResults {...this.props.bulkResults} />
          </Modal>
          <Modal
            isOpen={this.state.showAddGroupModal || this.state.showEditGroupModal}
            onRequestClose={this.handleAddClose}
            contentLabel="Add Groups"
            title={I18n.t(
              this.state.showAddGroupModal
                ? 'add.group.title'
                : 'edit.group.title'
            )}
          >
            <AddGroupForm
              onSubmit={
                this.state.showAddGroupModal
                  ? this.handleAddGroupSubmit
                  : this.handleEditGroupSubmit
              }
              initialValues={this.props.currentGroup}
              isEditing={this.state.showEditGroupModal}
              onDelete={this.handleDeleteGroup}
              onCancel={this.handleAddClose}
            />
          </Modal>
          <Modal
            isOpen={
              this.state.showAddCategoryModal || this.state.showEditCategoryModal
            }
            onRequestClose={this.handleAddClose}
            contentLabel="Add Category"
            title={I18n.t(
              this.state.showAddCategoryModal
                ? 'add.category.title'
                : 'edit.category.title'
            )}
          >
            <AddCategoryForm
              onSubmit={
                this.state.showAddCategoryModal
                  ? this.handleAddCategory
                  : this.handleEditCategorySubmit
              }
              initialValues={this.props.currentCategory}
              isEditing={this.state.showEditCategoryModal}
              onDelete={this.handleDeleteCategory}
              onCancel={this.handleAddClose}
            />
          </Modal>
          <Modal
            isOpen={this.state.showDeleteTagModal}
            onRequestClose={this.handleDeleteClose}
            contentLabel="Delete Tag"
            title={I18n.t('delete.deleteTag')}
          >
            <Confirm
              itemName={this.props.currentTag && this.props.currentTag.name}
              confirm={this.handleDeleteTagConfirm}
              deny={this.handleDeleteClose}
            />
          </Modal>
          <Modal
            isOpen={this.state.showEditCategoryListModal}
            onRequestClose={this.handleAddClose}
            contentLabel="Edit Category List"
            title={I18n.t('edit.category.title')}
          >
            <div className={css(styles.editList)}>
              <SearchInput
                  styles={{
                    base: styles.searchBase,
                  }}
                  onChange={this.handleCategorySearchChange}
                  onKeyPress={this.handleCategorySearch}
                />
              <ListItems
                onClick={this.handleEditCategory}
                noItemsMesagge={I18n.t('edit.category.noCategoriesFound')}
                list={this.props.searchedCategories}
              />
            </div>
          </Modal>
          <Modal
            isOpen={this.state.showEditGroupListModal}
            onRequestClose={this.handleAddClose}
            contentLabel="Edit Group List"
            title={I18n.t('edit.group.title')}
          >
            <div className={css(styles.editList)}>
              <SearchInput
                    styles={{
                      base: styles.searchBase
                    }}
                    onChange={this.handleGroupSearchChange}
                    onKeyPress={this.handleGroupSearch}
                  />
              <ListItems
                onClick={this.handleEditGroup}
                noItemsMesagge={I18n.t('edit.group.noGroupsFound')}
                list={this.props.searchedGroups}
              />
            </div>
          </Modal>
          <Modal
            isOpen={this.state.showDeleteGroupModal}
            onRequestClose={this.handleDeleteClose}
            contentLabel="Delete Group"
            title={I18n.t('delete.deleteGroup')}
          >
            <Confirm
              itemName={this.props.currentGroup && this.props.currentGroup.name}
              confirm={this.handleDeleteGroupConfirm}
              deny={this.handleDeleteClose}
            />
          </Modal>
          <Modal
            isOpen={this.state.showDeleteCategoryModal}
            onRequestClose={this.handleDeleteClose}
            contentLabel="Delete Category"
            title={I18n.t('delete.deleteCategory.title')}
          >
            <DeleteCategoryForm
              onSubmit={this.handleDeleteCategoryConfirm}
              deny={this.handleDeleteClose}
              itemName={
                this.props.currentCategory && this.props.currentCategory.name
              }
              itemId={this.props.currentCategory && this.props.currentCategory.id}
              categories={this.props.categories}
            />
          </Modal>

          <Notification message={this.props.notification} />
        </div>
      </Fragment>
    );
  }
}

const mapStateToProps = state => {
  const {
    auth: { account },
    sites: {
      list: sitesList,
      currentSite,
      loading: sitesLoading
    },
    areas,
    zones: { map: zones },
    locations: { map: locations, geoJson: locationsGeoJson },
    categories: { list: categories, currentCategory },
    groups: { list: groups, currentGroup },
    tags: {
      bulkResults,
      filters,
      selected,
      currentTag,
      historyGeodata,
      historySortedEvents,
      sorting
    }
  } = state;
  const tagsData = getFilteredTags(state);
  const tagsCount = tagsData.length;
  const currentAreaTags = getFilteredSortedTagsOfArea(state);
  const foundSelected = findSelectedTag(state);
  const superTagsList = getSuperTags(state);
  const searchedCategories = getFilteredCategories(state);
  const searchedGroups = getFilteredGroups(state);
  const columns = getMapViewColumns(state);

  return {
    account,
    bulkResults,
    sitesList,
    currentSite,
    currentCategory,
    currentGroup,
    sitesLoading,
    areas:
      currentSite &&
      currentSite.id in areas.map &&
      areas.map[currentSite.id],
    currentArea: areas.currentArea,
    zones,
    locations,
    categories,
    groups,
    filters,
    tagsData,
    tagsCount,
    currentAreaTags,
    searchedCategories,
    searchedGroups,
    superTagsList,
    selectedTag: foundSelected ? selected : null,
    sorting,
    currentTag,
    historyGeodata,
    historySortedEvents,
    loading: state.tags.loading,
    notification: state.notifications.notification,
    locationsGeoJson,
    columns
  };
};

const mapDispatchToProps = dispatch => {
  return {
    addInfo() {
      dispatch(addInfoAction(...arguments));
    },
    addTag() {
      dispatch(addTagAction(...arguments));
    },
    bulkUpload() {
      dispatch(bulkUploadAction(...arguments));
    },
    bulkUploadClear() {
      dispatch(bulkUploadClearAction(...arguments));
    },
    editTag() {
      dispatch(editTagAction(...arguments));
    },
    updateTagsTime() {
      dispatch(updateTagsTimeAction(...arguments));
    },
    getTags() {
      dispatch(getTagsAction(...arguments));
    },
    selectTag() {
      dispatch(selectTagAction(...arguments));
    },
    setCurrentTag() {
      dispatch(setCurrentTagAction(...arguments));
    },
    getAreas() {
      dispatch(getAreasAction(...arguments));
    },
    getSites() {
      dispatch(getOrgSitesAction(...arguments));
    },
    addFilter() {
      dispatch(addFilterAction(...arguments));
    },
    removeFilter() {
      dispatch(removeFilterAction(...arguments));
    },
    deleteTag() {
      dispatch(deleteTagAction(...arguments));
    },
    addCategory() {
      dispatch(addCategoryAction(...arguments));
    },
    getFilteredCategories() {
      dispatch(getFilteredCategoriesAction(...arguments))
    },
    getFilteredGroups() {
      dispatch(getFilteredGroupsAction(...arguments))
    },
    addGroup() {
      dispatch(addGroupAction(...arguments));
    },
    editCategory() {
      dispatch(editCategoryAction(...arguments));
    },
    setCurrentCategory() {
      dispatch(setCurrentCategoryAction(...arguments));
    },
    setCurrentGroup() {
      dispatch(setCurrentGroupAction(...arguments));
    },
    editGroup() {
      dispatch(editGroupAction(...arguments));
    },
    deleteGroup() {
      dispatch(deleteGroupAction(...arguments));
    },
    deleteCategory() {
      dispatch(deleteCategoryAction(...arguments));
    },
    getHistory() {
      dispatch(getHistoryAction(...arguments));
    },
    clearHistory() {
      dispatch(setHistoryAction('', null));
    },
    downloadCSVHistory() {
      dispatch(downloadCSVHistoryAction(...arguments));
    },
    setCurrentArea() {
      dispatch(setCurrentAreaAction(...arguments));
    },
    streamTags() {
      dispatch(streamTagsAction(...arguments));
    },
    closeStreamTags() {
      dispatch(closeStreamTagsAction(...arguments));
    },
    getLocationsGeoJson() {
      dispatch(getLocationsGeoJsonAction(...arguments))
    },
    clearTags() {
      dispatch(clearTagsAction(...arguments));
    },
    expandTag() {
      dispatch(expandCollapseAction(...arguments));
    },
    setSorting() {
      dispatch(setSortingAction(...arguments));
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Home);


// WEBPACK FOOTER //
// ./src/containers/home/Home.js